import * as React from "react";
const SvgFiRrVolume = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-volume_svg__a)">
      <path d="M20.807 4.29a1 1 0 1 0-1.415 1.415 8.913 8.913 0 0 1 0 12.59 1 1 0 1 0 1.415 1.415 10.916 10.916 0 0 0 0-15.42" />
      <path d="M18.1 7.291a1.002 1.002 0 0 0-1.42 1.415 4.66 4.66 0 0 1 0 6.588 1.004 1.004 0 0 0 .003 1.418 1 1 0 0 0 1.417-.003 6.666 6.666 0 0 0 0-9.418M13.82.2A12.05 12.05 0 0 0 6.266 5H5a5.01 5.01 0 0 0-5 5v4a5.01 5.01 0 0 0 5 5h1.266a12.06 12.06 0 0 0 7.554 4.8q.09.018.181.017a1 1 0 0 0 1-1V1.187A1 1 0 0 0 13.82.2M13 21.535a10.08 10.08 0 0 1-5.371-4.08A1 1 0 0 0 6.792 17H5a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h1.8a1 1 0 0 0 .837-.453A10.08 10.08 0 0 1 13 2.465z" />
    </g>
    <defs>
      <clipPath id="fi-rr-volume_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVolume;
